export default __webpack_public_path__ + "static/facebookads-cb097da8f808e419e4e6b260a93b6dae.jpg";